// extracted by mini-css-extract-plugin
export default {"loader":"searchable-select_loader__I7MA0","spin":"searchable-select_spin__bouJ8"};